import { ButtonType } from "./models";

export default function PrimaryButton({
  type,
  text,
  isExpanded,
  isDisabled,
  isInProgress,
  onClick,
  classNames,
}: {
  type: ButtonType;
  text: string;
  isExpanded: boolean;
  isDisabled?: boolean;
  isInProgress: boolean;
  onClick?: any;
  classNames?: string;
}) {
  return (
    <button
      type={type}
      className={`${classNames} m-button lg:!d-button rounded-full flex justify-center gap-3 items-center bg-primary text-font-on-primary select-none ${
        isExpanded ? "w-full py-4" : "w-fit py-3 px-8"
      } ${isInProgress || isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
      disabled={isInProgress || isDisabled}
      onClick={onClick}
    >
      {isInProgress ? (
        <span className="h-3.5 w-3.5 border-l-2 border-t-2 border-black rounded-full animate-spin"></span>
      ) : (
        ""
      )}
      <span>{text}</span>
    </button>
  );
}
